export const MATCH_REQUEST = 'MATCH_REQUEST'
export const MATCH_ERROR = 'MATCH_ERROR'
export const MATCH_ADD = 'MATCH_ADD'
export const MATCH_ADD_SUCCESS = 'MATCH_ADD_SUCCESS'
export const MATCH_UPDATE = 'MATCH_UPDATE'
export const MATCH_UPDATE_SUCCESS = 'MATCH_UPDATE_SUCCESS'
export const MATCH_RESET_STATE = 'MATCH_RESET_STATE'
export const MATCH_SET_SELECTED_DATE = 'MATCH_SET_SELECTED_DATE'
